import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  margin-top: 0px;
`;
